import { Injectable } from '@angular/core';
import { SFiTeam, User } from '../models/user';
import { CommonapiService } from './commonapi.service';

//   {
//     id: 1,
//     name: 'Dan Johnson, CSP',
//     avatar: 'dan.jpg',
//     designation:'Managing Partner',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 2,
//     name: 'Luann Roberts',
//     avatar: 'luann.jpg',
//     designation:'General Partner / Office Manager',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 3,
//     name: 'Reed Swenson, SMS, CHST',
//     avatar: 'reed.jpg',
//     designation:'Director of Operations',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 4,
//     name: 'Roman Lavrinenko, CSP, CHST',
//     avatar: 'roman.jpg',
//     designation:'Consulting Manager',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 5,
//     name: 'Chris Feagle',
//     avatar: 'chrisfeagle.jpg',
//     designation:'Area Manager-Colorado South',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 6,
//     name: 'Chris Sharp',
//     avatar: 'chrissharp.jpg',
//     designation:'Area Manager-Colorado North / Crane Specialist',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 7,
//     name: 'Enrique Colon Jr., CHST, CSST',
//     avatar: 'enrique.jpg',
//     designation:'Area Manager-Texas',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 8,
//     name: 'Aaron Hatcher',
//     avatar: 'aaron.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 9,
//     name: 'Andrew Spomer',
//     avatar: 'andrew.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 10,
//     name: 'Corey Parker',
//     avatar: 'corey.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 11,
//     name: 'Derek Johnson',
//     avatar: 'derek.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 12,
//     name: 'Jackson Babbs',
//     avatar: 'jackson.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 13,
//     name: 'Jamie Dillenbeck',
//     avatar: 'jamie.jpeg',
//     designation:'Admin Assistant/Training Coordinator',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 14,
//     name: 'John Cano',
//     avatar: 'johncano.jpg',
//     designation:'Regional Safety Consultant-North Texas',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 15,
//     name: 'Ken Mullinax',
//     avatar: 'kenmullinax.jpg',
//     designation:'Regional Safety Consultant-Colorado Springs',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 16,
//     name: 'Kryssy Enriquez',
//     avatar: 'kryssy.jpg',
//     designation:'Chief Organizational Officer',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 17,
//     name: 'Lex Wray',
//     avatar: 'lexwray.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 18,
//     name: 'Luis Cuevas',
//     avatar: 'luis.jpg',
//     designation:'Regional Safety Consultant-Central Texas',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 19,
//     name: 'Marco Saldivar',
//     avatar: 'marco.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 20,
//     name: 'Mark Hargett, CHST',
//     avatar: 'mark.png',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 21,
//     name: 'Matt Coleman',
//     avatar: 'mattcoleman.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 22,
//     name: 'Melissa Johnson',
//     avatar: 'melissa.jpg',
//     designation:'Administrative Assistant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 23,
//     name: 'Norm Teltow',
//     avatar: 'normteltow.jpg',
//     designation:'Sales Representative',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 24,
//     name: 'Omar Navarro',
//     avatar: 'avatar.png',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 25,
//     name: 'Patrick Monahan',
//     avatar: 'patrick.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 26,
//     name: 'Rene Salinas',
//     avatar: 'rene.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   },
//   {
//     id: 27,
//     name: 'Travis Lawson',
//     avatar: 'travis.jpg',
//     designation:'Safety Consultant',
//     email:'dan@sficompliance.com'
//   }
// ]);

@Injectable()
export class UserService {

  public objTeam:User[]=new Array();

  public sfiTeam:SFiTeam[]=new Array();

  sortingProperty: string = "ConsultantID";

  constructor(
    private commonApiService:CommonapiService
  ) { }

  // get all users
  async getUsers() {
    this.objTeam=new Array(); 
    const _obj = {
      Mode: "SEARCH",
      MemberId: "0",
      MemberName: "",     
      SortBy: "id",
      Sort: "ASC",
      PageNumber: 1,
      NoOfRecordsPerPage: 1000,
      DisplayFilter: 'Active',
      PropertyName: "SortOrder",
      SortingBy: true,      
    };
    let _dt=await this.commonApiService.postData("api/MarketingApi/DBTeamList/",_obj).toPromise();

    if(_dt && _dt[0] && _dt[0].dataSet && _dt[0].dataSet.mlTeamList && _dt[0].dataSet.mlTeamList.length>0)
    {
      const _data=_dt[0].dataSet.mlTeamList;

      console.log("consultant list",_data);

      _data.forEach(element => {
        this.objTeam.push({
          id: element.memberId,
          name: element.memberName,
          designation:element.designation,
          email:element.emailId,
          smalldescription:element.smallDescrip,
          fulldescription:element.fullDescrip,
          avatar: element.memberImage  
        });
      });
    }

    return this.objTeam;
  }

  // setUser(Id){
  //   this.UserId=Id;
  // } 

  // // find a specific user
  async getUserById(id) {
    this.objTeam=new Array(); 
    const _obj = {
      Mode: "SEARCH",
      MemberId: id,
      MemberName: "",     
      SortBy: "id",
      Sort: "ASC",
      PageNumber: 1,
      NoOfRecordsPerPage: 1000,
      DisplayFilter: 'Active'
    };
    let _dt=await this.commonApiService.postData("/api/MarketingController/DBTeamList",_obj).toPromise();

    if(_dt && _dt[0] && _dt[0].DataSet && _dt[0].DataSet.MLTeamList && _dt[0].DataSet.MLTeamList.length>0)
    {
      const _data=_dt[0].DataSet.MLTeamList;

      console.log(_data);

      _data.forEach(element => {
        this.objTeam.push({
          id: element.MemberId,
          name: element.MemberName,
          designation:element.Designation,
          email:element.EmailId,
          smalldescription:element.SmallDescrip,
          fulldescription:element.FullDescrip,
          avatar: element.MemberImage  
        });
      });
    }
    
    // //return usersPromise.then(users => users.find(user => user.id === this.UserId));

    // let user = this.objTeam.then(users => {
    //   return users.find(user => {
    //     return user.id === this.UserId;
    //   });
    // });

    return this.objTeam;
  }

  async getSfiTeam()
{
  this.sfiTeam=new Array(); 
  const _obj = {
    Mode: 3,
    ConsultantName: "",     
    PageNumber: 1,
    NoOfRecordsPerPage: 100,
    DisplayFilter: 'Active',
    SortingProperty: 'ConsultantID',
    SortingBy: 'ASC',
    EmailAddress:'',
    StateName:''
  };
  let _dt=await this.commonApiService.postData1("api/ConsultantApi/DBConsultantGetMarketingList/",_obj).toPromise();

console.log('Consultant list',_dt);
if(_dt && _dt[0] && _dt[0].dataSet && _dt[0].dataSet.mlConsultantList && _dt[0].dataSet.mlConsultantList.length>0)
    {
      const _data=_dt[0].dataSet.mlConsultantList;

      console.log(_data);
      let arra1=[];
      arra1 = _data.filter(x=> x.sortOrder == '')
      console.log("array1",arra1)
      let arra2=[];
      arra2 = _data.filter(x=> x.sortOrder != '')
      console.log("array2",arra2)
      let data = arra2.concat(arra1);
      console.log('final array', data)


      data.forEach(element => {
        this.sfiTeam.push({
          id: element.memberId,
          name: element.consultantName,
          designation:element.designation,
          email:element.emailAddress,
          avatar: element.memberImage   
        });
      });
    }

    return this.sfiTeam;

}
}